import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useSeo } from "@/hooks/useSeo";

const suggestions = [
  { to: "/", label: "回到首页", icon: "ri-home-4-line", description: "看看本周的焦点推荐" },
  { to: "/category", label: "影视分类", icon: "ri-film-line", description: "按题材、地区、年份筛选" },
  { to: "/news", label: "影视资讯", icon: "ri-newspaper-line", description: "最新动态与幕后花絮" },
];

export default function NotFound() {
  useSeo({
    title: "页面不存在 - 星光传媒",
    description: "你访问的页面不存在或已被移动，返回星光传媒首页继续浏览影视作品推荐与影视资讯。",
    keywords: "星光传媒,页面不存在",
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar currentLabel="首页" />
      <main className="flex-1 px-4 md:px-6 pt-28 md:pt-36 pb-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="bg-background-100 rounded-lg px-4 md:px-10 py-12 md:py-16">
            <div className="max-w-2xl mx-auto text-center">
              <p className="font-heading text-5xl md:text-7xl font-semibold text-background-300 leading-none mb-4">404</p>
              <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
                这一幕没有拍到
              </h1>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8">
                你访问的页面可能已被移动或删除。别急，我们还有别的可以看。
              </p>
              <div className="flex flex-wrap justify-center gap-3 mb-10">
                <Link
                  to="/"
                  className="h-11 px-5 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                  返回首页
                </Link>
                <Link
                  to="/category"
                  className="h-11 px-5 inline-flex items-center gap-2 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
                  去找点好看的
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-left">
                {suggestions.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="group bg-background-50 rounded-lg p-4 hover:bg-background-200/60 transition-colors cursor-pointer"
                  >
                    <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center mb-3">
                      <i className={`${item.icon} text-base w-4 h-4 flex items-center justify-center`}></i>
                    </span>
                    <p className="text-sm font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {item.label}
                    </p>
                    <p className="text-[11px] text-foreground-500 mt-1">{item.description}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}